import browser from "webextension-polyfill";
import { commandStorageKey } from "./command-library";
import { recordEvent } from "./event-recording";
import { getStartInfo } from "./start-info";
export async function checkLanguage(ipmId) {
    var _a;
    const { prefs } = getStartInfo();
    await prefs.untilLoaded;
    const commandStorage = prefs.get(commandStorageKey);
    if (!(ipmId in commandStorage)) {
        return;
    }
    const command = commandStorage[ipmId];
    if (typeof ((_a = command.attributes) === null || _a === void 0 ? void 0 : _a.language) !== "string") {
        return;
    }
    if (browser.i18n.getUILanguage() === command.attributes.language) {
        return;
    }
    recordEvent(command.ipm_id, command.command_name, "language_skew");
}
